import React from 'react';
import Comment, { IComment } from './Comment';
import styled from 'styled-components';
import { KatDivider } from '@amzn/katal-react';

export type CommentTypes = {
  commentList: Array<IComment> | undefined;
};

const CommentsLayout = styled.div``;
const Comments: React.FC<CommentTypes> = ({ commentList }) => {
  const comments = commentList?.map((comment) => {
    return (
      <div key={comment.id}>
        <Comment
          key={comment.id}
          id={comment.id}
          createdByUserId={comment.createdByUserId}
          content={comment.content}
          postedBy={comment.postedBy}
          time={comment.time}
          documentList={comment.documentList}
          correspondenceType={comment.correspondenceType}
        ></Comment>
        <KatDivider variant="athens"></KatDivider>
      </div>
    );
  });

  return <CommentsLayout>{comments}</CommentsLayout>;
};

export default Comments;
